<template>
  <div class="karada-stamps--container">
    <div class="karada-stamps--content karada-stamps--content__label">
      {{ $t("notebook.stampTitle") }}
    </div>
    <div class="karada-stamps--content karada-stamps--content__stamp">
      <stamp
        v-for="(stamp, index) in stampSources"
        :id="`stamp-${index}`"
        :key="index"
        :index="index"
        :fileName="stamp"
        :label="$store.state.labels.karadaStampLabels[index]"
        @toggleStamp="toggleStamp"
      />
    </div>
  </div>
</template>

<script>
import VueTypes from "vue-types";
import Stamp from "../../atoms/KaradaDiary/Stamp";

export default {
  components: {
    Stamp
  },
  methods: {
    toggleStamp(index) {
      this.$emit("setStampData", index);
    }
  },
  props: {
    stampData: {}
  },
  computed: {
    stampSources() {
      return {
        bowel: this.stampToiletSource,
        alcohol: this.stampAlcoholSource,
        exercise: this.stampExerciseSource,
        conditionGood: this.stampConditionGoodSource,
        conditionBad: this.stampConditionBadSource,
        medicine: this.stampMedicineSource
      };
    },
    stampToiletSource() {
      if (this.stampData.bowel) {
        return "stamp_toilet_on.svg";
      } else {
        return "stamp_toilet_off.svg";
      }
    },
    stampAlcoholSource() {
      if (this.stampData.alcohol) {
        return "stamp_drink_on.svg";
      } else {
        return "stamp_drink_off.svg";
      }
    },
    stampExerciseSource() {
      if (this.stampData.exercise) {
        return "stamp_exercise_on.svg";
      } else {
        return "stamp_exercise_off.svg";
      }
    },
    stampConditionGoodSource() {
      if (this.stampData.conditionGood) {
        return "stamp_good_on.svg";
      } else {
        return "stamp_good_off.svg";
      }
    },
    stampConditionBadSource() {
      if (this.stampData.conditionBad) {
        return "stamp_bad_on.svg";
      } else {
        return "stamp_bad_off.svg";
      }
    },
    stampMedicineSource() {
      if (this.stampData.medicine) {
        return "stamp_drag_on.svg";
      } else {
        return "stamp_drag_off.svg";
      }
    }
  }
};
</script>

<style scoped>
.karada-stamps--container {
  width: 100%;
}
.karada-stamps--content {
  margin-top: 20px;
  padding-left: 20px;
}
.karada-stamps--content__stamp {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
}
@media screen and (max-width: 769px) {
  .karada-stamps--content__stamp {
    grid-template-columns: repeat(3, 1fr);
  }
}
.karada-stamps--content__label {
  text-align: left;
}
</style>
